import type { ToolUIPart } from "ai";
import { tryDecodeToonString } from "@/lib/ai/convert/toon";

/**
 * Tool output を UI が描画できる値へ一度だけ変換する。
 *
 * TOON 文字列は署名生成と実描画で同じ結果を使い、判定のずれを防ぐ。
 */
export function getRenderableToolOutput(
  output: ToolUIPart["output"],
): ToolUIPart["output"] {
  if (typeof output !== "string") {
    return output;
  }

  const decoded = tryDecodeToonString(output);
  return decoded !== undefined ? decoded : output;
}
